<template>
  <div v-if="showAccountMenu" class="account-menu">
    <!-- Signed out: open the register/login dialog so the user can choose. -->
    <v-btn
      v-if="!candidateIsAuthenticated"
      text
      class="px-4 px-sm-6"
      @click="openAccountDialog"
    >
      <v-icon class="mr-0 mr-sm-2">mdi-account-outline</v-icon>
      <span class="d-none d-sm-inline">{{ $t('account.myAccount') }}</span>
    </v-btn>

    <!-- Signed in: a dropdown with the account actions. -->
    <v-menu v-else offset-y left>
      <template #activator="{ on, attrs }">
        <v-btn text v-bind="attrs" v-on="on" class="px-4 px-sm-6">
          <v-icon class="mr-0 mr-sm-2">mdi-account-circle-outline</v-icon>
          <span class="d-none d-sm-inline">{{ $t('account.myAccount') }}</span>
          <v-icon right>mdi-chevron-down</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item :to="profileLink" exact-path>
          <v-list-item-icon>
            <v-icon>mdi-account-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t('account.profile') }}</v-list-item-title>
        </v-list-item>

        <v-list-item :to="cockpitLink" exact-path>
          <v-list-item-icon>
            <v-icon>mdi-file-document-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            {{ $t('account.myApplications') }}
          </v-list-item-title>
        </v-list-item>

        <v-divider />

        <v-list-item @click="onLogout">
          <v-list-item-icon>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t('account.logout') }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import { eventBus } from '@/event-bus.js';

export default {
  name: 'AccountMenu',

  computed: {
    ...mapState('companyModule', {
      slug: 'slug',
      candidateAccountMode: 'candidateAccountMode'
    }),

    ...mapGetters('candidateModule', {
      candidateIsAuthenticated: 'isAuthenticated'
    }),

    showAccountMenu() {
      // Show where candidate accounts are enabled, or whenever someone is signed
      // in (so they can always reach logout).
      return this.candidateAccountMode > 0 || this.candidateIsAuthenticated;
    },

    cockpitLink() {
      return this.slug ? `/${this.slug}/cockpit` : '/';
    },

    profileLink() {
      return this.slug ? `/${this.slug}/cockpit/profile` : '/';
    }
  },

  methods: {
    ...mapActions('candidateModule', ['logout']),

    openAccountDialog() {
      // Let the user choose to sign up or log in, instead of jumping straight to
      // the Keycloak login page.
      eventBus.$emit('openRegister');
    },

    onLogout() {
      // Return to the tenant's jobs overview after logout, not the bare origin
      // (which would drop the client slug).
      const redirectUri = this.slug
        ? `${window.location.origin}/${this.slug}/jobs`
        : window.location.origin;

      this.logout(redirectUri);
    }
  }
};
</script>
